import { FormContainer } from '@/shared/components/form/FormElements';
import { MenuItem, TextField } from '@/shared/dynamicImports';
import { left, right } from '@/utils/directions';
import { colorAccent, colorFieldsBorder, colorText } from '@/utils/palette';
import { FormHelperText } from '@mui/material';
import styled from 'styled-components';
import { colorBackground } from '../../../utils/palette';

export const MaterialFormLabel = styled.span`
	margin: 0;
	font-size: 12px;
	color: ${colorText};

	${props =>
		props.bold &&
		`
  font-weight: 500;
  margin: 0 10px 0 10px;
  `}
`;

export const MaterialFormHelperText = styled(FormHelperText)`
	font-size: 12px;
	color: red;
	margin: 0 0 0 20px;
	font-family: 'Inter', sans-serif;
`;
export const MaterialFormTitle = styled.div`
	align-self: center;
	width: 8vw;
	margin-right: 20px;
	font-size: 12px;
	color: ${colorText};

	@media screen and (max-width: 576px) {
		width: 40vw;
		margin-right: 10px;
	}
`;

export const MaterialTextField = styled(TextField)`
	width: 100%;
	margin-bottom: 20px !important;
	font-size: 12px !important;

	div {
		color: ${colorText};
		font-size: 12px !important;
		font-family: 'Inter', sans-serif;
	}

	// When there's no error
	& > div:before {
		border-bottom-color: ${colorFieldsBorder};
	}

	// On hover, no error
	& > div:hover:before {
		border-bottom: 1px solid ${colorAccent} !important;
	}

	// After focus, no error
	& > div:after {
		border-color: ${colorAccent};
		font-size: 12px !important;
		font-family: 'Inter', sans-serif;
	}

	// Handle the error state by adding a condition for when the 'error' prop is true
	${({ error }) =>
		error &&
		`
    & > div:before {
      border-bottom-color: red !important;  // Change border color on error
    }

    & > div:after {
      border-color: red !important;  // Keep red border after error
    }

    label {
      color: red !important;  // Change label color to red
    }
  `}

	input,
  textarea {
		font-size: 12px !important;
		color: ${colorText};
	}

	helpertext {
		color: red;
	}

	label {
		${left}: 0;
		${right}: auto;
		color: ${colorAccent};
	}

	svg {
		${left}: auto;
		${right}: 0;
		fill: ${colorText};
	}
`;

export const MaterialFormOption = styled(MenuItem)`
	height: 30px !important;
	font-family: 'Inter', sans-serif;
	font-size: 12px !important;
	line-height: 18px !important;
	text-align: left;
	display: flex;
	justify-content: flex-start;
	background: ${colorBackground} !important;
	color: ${colorText} !important;

	&:hover {
		background: ${colorAccent} !important;
		color: white !important;
	}
`;

export const MaterialFormContainer = styled.form`
	padding-bottom: 50px;
	text-align: ${left};

	label {
		font-size: 12px;
		color: ${colorText};

		&[data-shrink='true'] {
			transform: translate(0, 1.5px) scale(0.85);
		}
	}

	h3 {
		margin-top: 40px;
	}

	span {
		color: ${colorText};
	}
`;

export const MaterialFormWrap = styled.div`
	display: flex;
`;

export const MaterialFormWizardContainer = styled(FormContainer)`
	max-width: 610px;
	// text-align: center;
	width: 100%;
	margin-top: 50px;
	margin-bottom: 100px;
	padding: 0 25px;
	justify-content: center;

	label {
		color: ${colorText};
	}

	input,
	textarea {
		width: 100%;
		padding: 5px 10px;
		font-size: 12px;
		height: 32px;
		transition: border 0.3s;
		background: transparent;
		border: none;
		color: ${colorText};

		value {
			text-align: left;
			color: ${colorText};
		}
	}
`;

export const MaterialFormWizardTitle = styled.h3`
	margin-bottom: 40px;
	margin-left: auto;
	margin-right: auto;
	font-weight: 500;
	text-align: center;
`;

export const MaterialFormWizardSubtitle = styled.h4`
	justify-content: start;
	margin-bottom: 30px;
`;

export const ButtonWrap = styled.div`
	margin-top: 15px;
	display: flex;
	background-color: ${colorBackground};
	justify-content: center;
	align-item: center;
	position: sticky;
	bottom: 0;
	padding: 16px 0;
	z-index: 1;
`;
